import Animations  from '../library/Animations';

window.addEventListener('preloader-done', () => {
	let animations  = new Animations('.animation', 'animated');

	// console.log('%c JavaScript entry file: /wp-content/themes/template/res/js/modules/Main.js ', 'background: #222; color: #bada55');
});


var $j = jQuery.noConflict();

$j(document).ready(function(){

	var navopen = 0;

	$j('#hidevideo').click(function(){
		$j('#videocontainer').removeClass('show');
	});

	$j('#videocontainer').click(function(){
		$j('#videocontainer').removeClass('show');
	});

	$j('#playbtn').click(function(){
		$j('#videocontainer').addClass('show');
	});


	$j('#burger').click(function(){

		if(navopen == 0) {
			navopen = 1;

			$j('#mobile-nav').removeClass('nav-close--done');
			$j('#mobile-nav-wrapper').removeClass('nav-close--content');

			$j('#mobile-nav').addClass('nav-open--done');
			$j('#mobile-nav-wrapper').addClass('nav-open--content');

		} else {
			navopen = 0;

			$j('#mobile-nav').removeClass('nav-open--done');
			$j('#mobile-nav-wrapper').removeClass('nav-open--content');

			$j('#mobile-nav').addClass('nav-close--done');
			$j('#mobile-nav-wrapper').addClass('nav-close--content');

		}

		$j('.burger').toggleClass('is-active');
		$j('body').toggleClass('nav-open');

	});

	$j('#burger__inner').click(function(){
		$j('#mobile-nav').toggleClass('nav-open--done');
		setTimeout(function(){
			$j('.burger').toggleClass('is-active');
			$j('body').toggleClass('nav-open');
		},0);
		setTimeout(function(){
			$j('#mobile-nav-wrapper').toggleClass('nav-open--content');
		},0);
	});

	/* FADE ANIMATION */
	$j('.fade-indicator').each(function(){
		if(isScrolledIntoView($j(this))){
			$j($j(this)).parent().addClass('fade-active');
		}
	});

	/* FADE FROM LEFT ANIMATION */
	$j('.fade-left-indicator').each(function(){
		if(isScrolledIntoView($j(this))){
			$j($j(this)).parent().addClass('fade-left-active');
		}
	});

	/* PIC ANIMATION */
	$j('.pic-ani').each(function(){
		if(isScrolledIntoView(jQuery(this))){
			var myelement = this;
			window.setTimeout(function(){ $j(myelement).addClass('pic-ani-active'); },800);
			window.setTimeout(function(){ $j(myelement).addClass('pic-ani-inactive'); },1200);
		}
	});




	/* UP COUNT */

	$j('.counter').each(function() {
	  var $this = $j(this),
	      countTo = $this.attr('data-count');

	  $j({ countNum: $this.text()}).animate({
	    countNum: countTo
	  },

	  {

	    duration: 3000,
	    easing:'linear',
	    step: function() {
	      $this.text(Math.floor(this.countNum));
	    },
	    complete: function() {
	      $this.text(this.countNum);
	      //alert('finished');
	    }

	  });



	});




});

$j(window).scroll(function(){

	/* FADE ANIMATION */
	$j('.fade-indicator').each(function(){
		if(isScrolledIntoView($j(this))){
			$j($j(this)).parent().addClass('fade-active');
		}
	});

	/* FADE FROM LEFT ANIMATION */
	$j('.fade-left-indicator').each(function(){
		if(isScrolledIntoView($j(this))){
			$j($j(this)).parent().addClass('fade-left-active');
		}
	});

	/* PIC ANIMATION */
	$j('.pic-ani').each(function(){
		if(isScrolledIntoView(jQuery(this))){
			$j($j(this)).addClass('pic-ani-active');
			var myelement = this;
			window.setTimeout(function(){ $j(myelement).addClass('pic-ani-inactive'); },400);
		}
	});




});



function isScrolledIntoView(elem){
		var $elem = $j(elem);
		var $window = $j(window);

		var docViewTop = $window.scrollTop();
		var docViewBottom = docViewTop + $window.height();

		var elemTop = $elem.offset().top;
		var elemBottom = elemTop + $elem.height();

		return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Main.js